var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowSmall = function SvgArrowSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33191 4.27631C5.57222 4.57089 5.55476 5.00561 5.28016 5.28022L1.28016 9.28022C0.987264 9.57311 0.512503 9.57311 0.21961 9.28022C-0.0732832 8.98732 -0.0732832 8.51256 0.21961 8.21967L3.68934 4.74994L0.21961 1.28022C-0.0732837 0.987323 -0.0732837 0.512563 0.21961 0.21967C0.512503 -0.0732233 0.987264 -0.0732233 1.28016 0.21967L5.28016 4.21967L5.33191 4.27631Z",
    fill: "currentColor"
  })));
};
export default SvgArrowSmall;